import type {
  EntitlementAccount,
  EntitlementTemplate,
  EntitlementCard,
  LedgerEntry,
} from '@/api/types'

/**
 * 权益 Mock 数据 (ENT-01)
 * K6: 禁止负余额；冻结顺延有效期；消耗最早到期优先；人工调整不可变账本
 * Q3决策: EntitlementTemplate增加courseTypes绑定课程类型
 */

// ===== 会员卡模板 =====

export const mockEntitlementTemplates: EntitlementTemplate[] = [
  {
    id: 'etpl-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '篮球课卡10次',
    type: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    faceValueMinor: 150000,
    currency: 'CNY',
    sellingPriceMinor: 128000,
    durationDays: 90,
    description: '10次篮球课程，有效期90天',
    status: 'ACTIVE',
    createdAt: '2025-08-01T10:00:00+08:00',
    updatedAt: '2025-08-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'etpl-002',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '私教体能课卡5次',
    type: 'COUNT_CARD',
    courseTypes: ['PRIVATE'],
    faceValueMinor: 100000,
    currency: 'CNY',
    sellingPriceMinor: 88000,
    durationDays: 60,
    description: '5次私教体能训练，有效期60天',
    status: 'ACTIVE',
    createdAt: '2025-08-05T10:00:00+08:00',
    updatedAt: '2025-08-05T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'etpl-003',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '足球课卡10次',
    type: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    faceValueMinor: 150000,
    currency: 'CNY',
    sellingPriceMinor: 128000,
    durationDays: 90,
    description: '10次足球课程，有效期90天',
    status: 'ACTIVE',
    createdAt: '2025-08-10T10:00:00+08:00',
    updatedAt: '2025-08-10T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'etpl-004',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '游泳储值卡',
    type: 'STORED_VALUE',
    courseTypes: ['GROUP'],
    faceValueMinor: 200000,
    currency: 'CNY',
    sellingPriceMinor: 180000,
    durationDays: 180,
    description: '储值卡2000元，有效期180天',
    status: 'ACTIVE',
    createdAt: '2025-08-15T10:00:00+08:00',
    updatedAt: '2025-08-15T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'etpl-005',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '年度会员卡',
    type: 'TIME_CARD',
    courseTypes: ['GROUP', 'PRIVATE', 'TRIAL'],
    faceValueMinor: 360000,
    currency: 'CNY',
    sellingPriceMinor: 299000,
    durationDays: 365,
    description: '年度会员，畅享所有课程',
    status: 'ACTIVE',
    createdAt: '2025-07-01T10:00:00+08:00',
    updatedAt: '2025-07-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'etpl-006',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '舞蹈课卡8次（停售）',
    type: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    faceValueMinor: 120000,
    currency: 'CNY',
    sellingPriceMinor: 99000,
    durationDays: 90,
    description: '8次舞蹈课程',
    status: 'INACTIVE',
    createdAt: '2025-06-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-principal-001',
  },
]

// ===== 权益账户 =====

export const mockEntitlementAccounts: EntitlementAccount[] = [
  {
    id: 'ea-001',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-001',
    subjectId: 'etpl-001',
    balanceMinor: 105000,
    currency: 'CNY',
    earliestExpireAt: '2026-01-15T00:00:00+08:00',
    status: 'ACTIVE',
    cardName: '篮球课卡10次',
    cardType: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    remainingConsumption: 7,
    issuedAt: '2025-08-20T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-001',
    classId: 'cg-001',
    createdAt: '2025-08-20T10:00:00+08:00',
    updatedAt: '2025-10-11T10:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'ea-002',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-002',
    subjectId: 'etpl-002',
    balanceMinor: 60000,
    currency: 'CNY',
    earliestExpireAt: '2025-12-20T00:00:00+08:00',
    status: 'ACTIVE',
    cardName: '私教体能课卡5次',
    cardType: 'COUNT_CARD',
    courseTypes: ['PRIVATE'],
    remainingConsumption: 3,
    issuedAt: '2025-09-01T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-002',
    classId: 'cg-002',
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-10-13T13:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ea-003',
    brandId: 'b-001',
    campusId: 'c-002',
    accountId: 'cu-003',
    subjectId: 'etpl-003',
    balanceMinor: 120000,
    currency: 'CNY',
    earliestExpireAt: '2026-02-10T00:00:00+08:00',
    status: 'ACTIVE',
    cardName: '足球课卡10次',
    cardType: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    remainingConsumption: 8,
    issuedAt: '2025-08-25T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-003',
    classId: 'cg-003',
    createdAt: '2025-08-25T10:00:00+08:00',
    updatedAt: '2025-10-05T11:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'ea-004',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-004',
    subjectId: 'etpl-004',
    balanceMinor: 164000,
    currency: 'CNY',
    earliestExpireAt: '2026-02-14T00:00:00+08:00',
    status: 'ACTIVE',
    cardName: '游泳储值卡',
    cardType: 'STORED_VALUE',
    courseTypes: ['GROUP'],
    remainingConsumption: 0,
    issuedAt: '2025-09-15T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-004',
    classId: 'cg-004',
    createdAt: '2025-09-15T10:00:00+08:00',
    updatedAt: '2025-10-14T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ea-005',
    brandId: 'b-001',
    campusId: 'c-002',
    accountId: 'cu-007',
    subjectId: 'etpl-005',
    balanceMinor: 299000,
    currency: 'CNY',
    earliestExpireAt: '2026-07-01T00:00:00+08:00',
    status: 'FROZEN',
    cardName: '年度会员卡',
    cardType: 'TIME_CARD',
    courseTypes: ['GROUP', 'PRIVATE', 'TRIAL'],
    remainingConsumption: 999,
    issuedAt: '2025-07-05T10:00:00+08:00',
    frozenAt: '2025-10-10T10:00:00+08:00',
    studentId: 'cu-007',
    createdAt: '2025-07-05T10:00:00+08:00',
    updatedAt: '2025-10-10T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ea-006',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-005',
    subjectId: 'etpl-001',
    balanceMinor: 0,
    currency: 'CNY',
    earliestExpireAt: null,
    status: 'EXPIRED',
    cardName: '篮球课卡10次',
    cardType: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    remainingConsumption: 0,
    issuedAt: '2025-06-10T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-005',
    classId: 'cg-001',
    createdAt: '2025-06-10T10:00:00+08:00',
    updatedAt: '2025-09-10T00:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'ea-007',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-008',
    subjectId: 'etpl-004',
    balanceMinor: 180000,
    currency: 'CNY',
    earliestExpireAt: '2026-03-01T00:00:00+08:00',
    status: 'ACTIVE',
    cardName: '游泳储值卡',
    cardType: 'STORED_VALUE',
    courseTypes: ['GROUP'],
    remainingConsumption: 0,
    issuedAt: '2025-09-20T10:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-008',
    classId: 'cg-004',
    createdAt: '2025-09-20T10:00:00+08:00',
    updatedAt: '2025-09-20T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'et-006',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-001',
    subjectId: 'etpl-001',
    balanceMinor: 0,
    currency: 'CNY',
    earliestExpireAt: null,
    status: 'CANCELLED',
    cardName: '游泳课卡5次',
    cardType: 'COUNT_CARD',
    courseTypes: ['GROUP'],
    remainingConsumption: 0,
    issuedAt: '2025-10-23T08:00:00+08:00',
    frozenAt: null,
    studentId: 'cu-001',
    createdAt: '2025-10-23T08:00:00+08:00',
    updatedAt: '2025-10-25T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]

// ===== 权益卡 =====

export const mockEntitlementCards: EntitlementCard[] = [
  {
    id: 'ec-001',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-001',
    templateId: 'etpl-001',
    name: '篮球课卡10次',
    balanceMinor: 105000,
    currency: 'CNY',
    expireAt: '2026-01-15T00:00:00+08:00',
    status: 'ACTIVE',
    createdAt: '2025-08-20T10:00:00+08:00',
    updatedAt: '2025-10-11T10:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'ec-002',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-002',
    templateId: 'etpl-002',
    name: '私教体能课卡5次',
    balanceMinor: 60000,
    currency: 'CNY',
    expireAt: '2025-12-20T00:00:00+08:00',
    status: 'ACTIVE',
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-10-13T13:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ec-003',
    brandId: 'b-001',
    campusId: 'c-002',
    accountId: 'cu-003',
    templateId: 'etpl-003',
    name: '足球课卡10次',
    balanceMinor: 120000,
    currency: 'CNY',
    expireAt: '2026-02-10T00:00:00+08:00',
    status: 'ACTIVE',
    createdAt: '2025-08-25T10:00:00+08:00',
    updatedAt: '2025-10-05T11:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'ec-004',
    brandId: 'b-001',
    campusId: 'c-001',
    accountId: 'cu-004',
    templateId: 'etpl-004',
    name: '游泳储值卡',
    balanceMinor: 164000,
    currency: 'CNY',
    expireAt: '2026-02-14T00:00:00+08:00',
    status: 'ACTIVE',
    createdAt: '2025-09-15T10:00:00+08:00',
    updatedAt: '2025-10-14T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ec-005',
    brandId: 'b-001',
    campusId: 'c-002',
    accountId: 'cu-007',
    templateId: 'etpl-005',
    name: '年度会员卡',
    balanceMinor: 299000,
    currency: 'CNY',
    expireAt: '2026-07-01T00:00:00+08:00',
    status: 'FROZEN',
    createdAt: '2025-07-05T10:00:00+08:00',
    updatedAt: '2025-10-10T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-principal-001',
  },
]

// ===== 账本流水 =====

export const mockLedgerEntries: LedgerEntry[] = [
  {
    id: 'le-001',
    entitlementAccountId: 'ea-001',
    type: 'ISSUED',
    amountMinor: 150000,
    currency: 'CNY',
    reason: '办卡充值 — 篮球课卡10次',
    relatedObjectId: 'etpl-001',
    receiptUrl: 'https://example.com/receipt/001.jpg',
    createdAt: '2025-08-20T10:00:00+08:00',
    updatedAt: '2025-08-20T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'le-002',
    entitlementAccountId: 'ea-001',
    type: 'DEDUCT',
    amountMinor: 15000,
    currency: 'CNY',
    reason: '预约扣费 — 篮球班 ts-001',
    relatedObjectId: 'bk-004',
    createdAt: '2025-10-04T08:30:00+08:00',
    updatedAt: '2025-10-04T08:30:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'le-003',
    entitlementAccountId: 'ea-001',
    type: 'DEDUCT',
    amountMinor: 15000,
    currency: 'CNY',
    reason: '预约扣费 — 篮球班 ts-002',
    relatedObjectId: 'bk-009',
    createdAt: '2025-10-11T08:30:00+08:00',
    updatedAt: '2025-10-11T08:30:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'le-004',
    entitlementAccountId: 'ea-001',
    type: 'DEDUCT',
    amountMinor: 15000,
    currency: 'CNY',
    reason: '预约扣费 — 篮球班 ts-003',
    relatedObjectId: 'bk-001',
    createdAt: '2025-10-15T08:00:00+08:00',
    updatedAt: '2025-10-15T08:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'le-005',
    entitlementAccountId: 'ea-002',
    type: 'ISSUED',
    amountMinor: 100000,
    currency: 'CNY',
    reason: '办卡充值 — 私教体能课卡5次',
    relatedObjectId: 'etpl-002',
    receiptUrl: 'https://example.com/receipt/005.jpg',
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'le-006',
    entitlementAccountId: 'ea-002',
    type: 'DEDUCT',
    amountMinor: 20000,
    currency: 'CNY',
    reason: '预约扣费 — 私教 ts-005',
    relatedObjectId: 'bk-002',
    createdAt: '2025-10-13T13:00:00+08:00',
    updatedAt: '2025-10-13T13:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'le-007',
    entitlementAccountId: 'ea-003',
    type: 'ISSUED',
    amountMinor: 150000,
    currency: 'CNY',
    reason: '办卡充值 — 足球课卡10次',
    relatedObjectId: 'etpl-003',
    templateName: '足球课卡10次',
    receiptUrl: 'https://example.com/receipt/007.jpg',
    createdAt: '2025-08-25T10:00:00+08:00',
    updatedAt: '2025-08-25T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'le-008',
    entitlementAccountId: 'ea-003',
    type: 'DEDUCT',
    amountMinor: 18000,
    currency: 'CNY',
    reason: '预约扣费 — 足球班 ts-006',
    relatedObjectId: 'bk-003',
    createdAt: '2025-10-05T09:30:00+08:00',
    updatedAt: '2025-10-05T09:30:00+08:00',
    createdBy: 'u-teacher-002',
    updatedBy: 'system',
  },
  {
    id: 'le-009',
    entitlementAccountId: 'ea-003',
    type: 'REFUND_COURSE',
    amountMinor: 18000,
    currency: 'CNY',
    reason: '取消退还 — 取消足球班预约 bk-006',
    relatedObjectId: 'bk-006',
    createdAt: '2025-10-11T14:00:00+08:00',
    updatedAt: '2025-10-11T14:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'le-013',
    entitlementAccountId: 'ea-003',
    type: 'REFUND_CARD',
    amountMinor: -80000,
    currency: 'CNY',
    reason: '会员卡退卡 — 足球课卡10次退卡',
    relatedObjectId: 'etpl-003',
    createdAt: '2025-09-15T14:30:00+08:00',
    updatedAt: '2025-09-15T14:30:00+08:00',
    createdBy: 'u-001',
    updatedBy: 'u-001',
  },
  {
    id: 'le-010',
    entitlementAccountId: 'ea-004',
    type: 'ISSUED',
    amountMinor: 200000,
    currency: 'CNY',
    reason: '办卡充值 — 游泳储值卡',
    relatedObjectId: 'etpl-004',
    receiptUrl: 'https://example.com/receipt/010.jpg',
    createdAt: '2025-09-15T10:00:00+08:00',
    updatedAt: '2025-09-15T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'le-011',
    entitlementAccountId: 'ea-004',
    type: 'DEDUCT',
    amountMinor: 12000,
    currency: 'CNY',
    reason: '预约扣费 — 游泳班 ts-008（NOSHOW）',
    relatedObjectId: 'bk-005',
    createdAt: '2025-10-08T15:30:00+08:00',
    updatedAt: '2025-10-08T17:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-teacher-001',
  },
  {
    id: 'le-012',
    entitlementAccountId: 'ea-004',
    type: 'DEDUCT',
    amountMinor: 12000,
    currency: 'CNY',
    reason: '预约扣费 — 游泳班 ts-009',
    relatedObjectId: 'bk-007',
    createdAt: '2025-10-14T15:00:00+08:00',
    updatedAt: '2025-10-14T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]
